import React from 'react'
import {format} from 'd3-format'
import {timeFormat} from 'd3-time-format'
import {SingleValueTooltip} from 'react-stockcharts/lib/tooltip'

export const OHLCTooltip = ({origin}) => {
  return(
    <g transform={`translate(${origin.x},${origin.y})`}>
      <SingleValueTooltip
        yAccessor={d => new Date(d.date)}
        yDisplayFormat={timeFormat('%m/%d/%Y')}
        yLabel={'Date'}
        origin={[0,0]}
        fontSize={12.8}
        fontFamily='GothamHTF'
        labelFill='rgb(164, 164, 164)'
        valueFill='rgb(164, 164, 164)'
      />
      {items.map(({value, label}, index) =>
        <g key={value} transform={`translate(${(index+1)*102 + 38},0)`}>
          <SingleValueTooltip
            yAccessor={d => d[value]}
            yDisplayFormat={value === 'volume' ? format('.4s') : format('.2f')}
            yLabel={label}
            origin={[0,0]}
            fontSize={12.8}
            fontFamily='GothamHTF'
            labelFill='rgb(164, 164, 164)'
            valueFill='rgb(70, 70, 70)'
          />
          <g transform={'translate(-14,-12)'}>
            <path
              fillRule='evenodd'
              opacity='0.302'
              fill='rgb(214, 214, 214)'
              d='M-0.000,-0.000 L1.000,-0.000 L1.000,18.000 L-0.000,18.000 L-0.000,-0.000 Z'
            />
          </g>
        </g>
      )}
    </g>
  )
}

const items = [{
  label: 'O',
  value: 'open'
}, {
  label: 'H',
  value: 'high'
}, {
  label: 'L',
  value: 'low'
}, {
  label: 'C',
  value: 'close'
}, {
  label: 'Vol',
  value: 'volume'
}]
